import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=43c22d05&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=43c22d05&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c22d05",
  null
  
)

export default component.exports